export interface TimeTrackingImportColumnMapping {
    employeeColumn: string;
    employeeName: string;
    dateColumn: string;
    hoursColumn: string;
    projectOrAbsenceColumn: string;
    typeColumn: string;
    noteColumn: string;
    tagsColumn: string;
}

export type TimeTrackingImportDataMappingAction = 'map' | 'create';

export type TimeTrackingImportDataMappingTarget =
    | 'project'
    | 'shiftType'
    | 'absenceType'
    | 'tag'
    | 'employee'
    | 'unknown';

export interface TimeTrackingImportDataMappingDto {
    field: string;
    sourceValue: string;
    target: TimeTrackingImportDataMappingTarget;
    action: TimeTrackingImportDataMappingAction;
    targetId?: number | null;
    targetName?: string;
}

export interface TimeTrackingImportRequestDto extends TimeTrackingImportColumnMapping {
    file: File;
    skipDuplicates?: boolean;
    skipErrors?: boolean;
    dataMappings?: TimeTrackingImportDataMappingDto[];
    // Service column with an explicit shift/absence value — written by buildMappedImportFile only
    // for rows added by hand in the preview. For file rows the value is empty, and the server
    // detects the entity kind from the data, as before.
    entityKindColumn?: string;
    /** Service column with the overtime flag, filled for the same rows. */
    overtimeColumn?: string;
}

export enum TimeTrackingImportRowStatus {
    Ready = 1,
    Warning = 2,
    Error = 3,
}

export enum TimeTrackingImportEntityKind {
    Shift = 1,
    Absence = 2,
}

export type TimeTrackingImportEntityKindValue =
    | TimeTrackingImportEntityKind
    | keyof typeof TimeTrackingImportEntityKind
    | 'shift'
    | 'absence';

export interface TimeTrackingImportIssueDto {
    code: string;
    message: string;
    field: string;
    value: string;
}

export interface TimeTrackingImportPreviewRowDto {
    rowNumber: number;
    employee: string;
    date: string;
    hours: string;
    projectOrAbsence: string;
    type: string;
    note: string;
    tags: string;
    entityKind?: TimeTrackingImportEntityKindValue | null;
    isOvertime?: boolean;
    status: TimeTrackingImportRowStatus;
    warnings: TimeTrackingImportIssueDto[];
    errors: TimeTrackingImportIssueDto[];
}

export interface TimeTrackingImportUnresolvedDto {
    field: string;
    value: string;
    rowNumbers: number[];
}

export interface TimeTrackingImportPreviewDto {
    totalRows: number;
    readyRows: number;
    warningRows: number;
    errorRows: number;
    unresolvedRows: number;
    rows: TimeTrackingImportPreviewRowDto[];
    unresolved: TimeTrackingImportUnresolvedDto[];
}

export interface TimeTrackingImportSummaryDto {
    success: boolean;
    totalRows: number;
    importedShifts: number;
    importedAbsences: number;
    skippedDuplicates: number;
    skippedErrors: number;
    warningRows: number;
    errorRows: number;
    unresolvedRows: number;
    auditId?: number | null;
    globalErrors: string[];
    rowsWithErrors: TimeTrackingImportPreviewRowDto[];
}
